import { render } from "./hydw.vue?vue&type=template&id=973c094c&scoped=true&ts=true"
import script from "./hydw.vue?vue&type=script&lang=ts"
export * from "./hydw.vue?vue&type=script&lang=ts"

import "./hydw.vue?vue&type=style&index=0&id=973c094c&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973c094c"]])

export default __exports__